(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["global-collection-filters"] && !Shopify.designMode) return;
  try {
    
  const host = document.querySelector('[data-section-id]');
  if (host) {
    const sectionIds = [
      ...new Set(
        Array.from(document.querySelectorAll('results-list[section-id]'))
          .map((element) => element.getAttribute('section-id'))
          .filter(Boolean)
      ),
    ];

    host.querySelectorAll('facets-form-component').forEach((component) => {
      if (sectionIds.length > 0) {
        component.setAttribute('section-ids', sectionIds.join(','));
        component.setAttribute('section-id', sectionIds[0]);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-faqs"] && !Shopify.designMode) return;
  try {
    
  class MainFaqs extends HTMLElement {
    connectedCallback() {
      this.searchInput = this.querySelector('[ref="searchInput"]');
      this.resultsLabel = this.querySelector('[ref="resultsLabel"]');
      this.emptyState = this.querySelector('[ref="emptyState"]');
      this.items = [...this.querySelectorAll('[data-faq-item]')];
      this.categoryButtons = [...this.querySelectorAll('[data-category-filter]')];
      this.activeCategory = 'all';

      if (!this.searchInput || this.items.length === 0) return;

      this.#hydrateFromUrl();
      this.#bindEvents();
      this.#applyFilters();
    }

    #bindEvents() {
      this.searchInput.addEventListener('input', () => {
        this.#applyFilters();
      });

      for (const button of this.categoryButtons) {
        button.addEventListener('click', () => {
          this.activeCategory = button.dataset.categoryFilter || 'all';
          this.#syncCategoryUi();
          this.#applyFilters();
        });
      }
    }

    #hydrateFromUrl() {
      const url = new URL(window.location.href);
      const query = (url.searchParams.get('faq') || '').trim();
      const category = (url.searchParams.get('faq_category') || 'all').trim();

      this.searchInput.value = query;
      this.activeCategory = category || 'all';
      this.#syncCategoryUi();
    }

    #syncCategoryUi() {
      for (const button of this.categoryButtons) {
        const isActive = (button.dataset.categoryFilter || 'all') === this.activeCategory;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', String(isActive));
      }
    }

    #applyFilters() {
      const query = this.searchInput.value.trim().toLowerCase();
      let visibleCount = 0;

      for (const item of this.items) {
        const searchText = item.dataset.faqSearch || '';
        const category = item.dataset.faqCategory || '';
        const matchesQuery = query === '' || searchText.includes(query);
        const matchesCategory = this.activeCategory === 'all' || category === this.activeCategory;
        const isVisible = matchesQuery && matchesCategory;

        item.hidden = !isVisible;
        if (isVisible) visibleCount += 1;
      }

      this.#updateResults(visibleCount, query);
      this.#syncUrl(query);
    }

    #updateResults(visibleCount, query) {
      if (!this.resultsLabel || !this.emptyState) return;

      if (visibleCount === 0) {
        this.emptyState.hidden = false;
        this.resultsLabel.textContent = query
          ? `No matches for "${query}".`
          : 'No FAQ entries are currently available.';
        return;
      }

      this.emptyState.hidden = true;
      this.resultsLabel.textContent = `${visibleCount} FAQ${visibleCount === 1 ? '' : 's'} shown`;
    }

    #syncUrl(query) {
      const url = new URL(window.location.href);

      if (query) {
        url.searchParams.set('faq', query);
      } else {
        url.searchParams.delete('faq');
      }

      if (this.activeCategory !== 'all') {
        url.searchParams.set('faq_category', this.activeCategory);
      } else {
        url.searchParams.delete('faq_category');
      }

      window.history.replaceState({}, '', url.toString());
    }
  }

  if (!customElements.get('main-faqs')) {
    customElements.define('main-faqs', MainFaqs);
  }

  } catch(e) { console.error(e); }
})();
})();
